import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { CheckCircleFill } from 'react-bootstrap-icons';
import './ReactivateSubscriptionModal.css';

interface ReactivateSubscriptionModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  loading: boolean;
}

const ReactivateSubscriptionModal: React.FC<ReactivateSubscriptionModalProps> = ({
  show,
  onHide,
  onConfirm,
  loading,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="reactivate-subscription-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <CheckCircleFill className="success-icon" />
          <span>Reactivate Subscription</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Would you like to reactivate your subscription? Your billing will resume at the end of your current period.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="link"
          onClick={onHide}
          className="cancel-btn"
          disabled={loading}
        >
          CANCEL
        </Button>
        <Button
          variant="success"
          onClick={onConfirm}
          className="action-btn"
          disabled={loading}
        >
          {loading ? <Spinner size="sm" /> : 'Confirm'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReactivateSubscriptionModal;
